import React from 'react'
import '../../styles/_Contact.css'
import { Grid, Row, Col } from 'react-bootstrap'
import SideBar from '../SideBar'
import MenuCONT from './Menu_cont'
import { ContactForm, ContactInfo, ContactIcons } from '../Contact/Info'
import { connect } from 'redux-zero/react'

const Info = ({isSpanish}) => {
  return (
    <Row className='info__container'>
      <div className='info__container--greeting'>
        {isSpanish === true ? <h3>¡Gracias por tu tiempo!</h3> : <h3>Thanks for your time!</h3>}
        {isSpanish === true ? <p>Si te gusto mi trabajo y estas interesado en realizar un proyecto juntos no dudes en escribirme.</p> : <p>If you enjoyed it and want to talk to me, don't doubt in dropping a line.</p>}
      </div>
      <ContactInfo isSpanish={isSpanish} />
      <ContactForm isSpanish={isSpanish} />
      <ContactIcons isSpanish={isSpanish} />
    </Row>
  )
}

const ContactContainer = ({isSpanish}) => {
  return (
    <Col lg={9} md={9} id='contact__container'>
      <MenuCONT isSpanish={isSpanish} />
      <Info isSpanish={isSpanish} />
    </Col>
  )
}

const ContactView = ({isSpanish}) => {
  return (
    <Grid fluid>
      <Row>
        <SideBar />
        <ContactContainer isSpanish={isSpanish} />
      </Row>
    </Grid>
  )
}

// export default ContactView;
const mapToProps = ({ isSpanish }) => ({ isSpanish })
export default connect(mapToProps)(ContactView)



// WEBPACK FOOTER //
// ./src/components/Contact/Contact.js